import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';

const Inventory = withLazyLoading(() => import('../../pages/Inventory'));
const InventoryOptions = withLazyLoading(() => import('../../pages/InventoryOptions'));
const Solution = withLazyLoading(() => import('../../pages/Solution'));
const SolutionDetail = withLazyLoading(() => import('../../pages/SolutionDetail'));
const SolutionDetailsForChemical = withLazyLoading(
  () => import('../../pages/SolutionDetailsForChemical')
);
const ChemicalLog = withLazyLoading(() => import('../../pages/ChemicalLog'));
const InventoryCategoryLogs = withLazyLoading(() => import('../../pages/InventoryCategoryLogs'));
const StoreManagement = withLazyLoading(() => import('../../pages/StoreManagement'));
const StoreConfiguration = withLazyLoading(() => import('../../pages/StoreConfiguration'));
const StoreDetails = withLazyLoading(() => import('../../pages/StoreDetails'));

const inventoryRoutes = [
  { // obsolete
    path: '/inventory/:id',
    handle: createCrumbHandle('Inventory'),
    children: [
      {
        index: true,
        element: withPostHogTracker(<Inventory />),
        // authz-v2 TODO: Inventory_View_R — gate server-side / useCan at component level
      },
    ]
  },
  {
    path: 'StoreMaintenance',
    element: <InventoryOptions />,
    handle: createCrumbHandle('Store Maintenance'),
  },
  {
    path: '/Solution',
    element: <Solution />,
    handle: createCrumbHandle('Solutions'),
  },
  {
    path: '/SolutionDetail',
    element: <SolutionDetail />,
    // authz-v2 TODO: StoreManagement_Usage_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Solution Details'),
  },
  {
    // @Obselete
    path: '/InventoryOptions/:id',
    element: <InventoryOptions />,
    handle: createCrumbHandle('Inventory Options'),
  },
  {
    path: '/Chemicals/:plantId',
    element: withPostHogTracker(<InventoryCategoryLogs />),
    // authz-v2 TODO: StoreManagement_Manage_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Chemicals'),
  },
  {
    path: '/Consumables/:plantId',
    element: <InventoryCategoryLogs />,
    // authz-v2 TODO: StoreManagement_Manage_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Consumables'),
  },
  {
    path: '/ElectricalSpare/:plantId',
    element: <InventoryCategoryLogs />,
    // authz-v2 TODO: StoreManagement_Manage_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Electrical Spares'),
  },
  {
    path: '/MechanicalSpare/:plantId',
    element: <InventoryCategoryLogs />,
    // authz-v2 TODO: StoreManagement_Manage_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Mechanical Spares'),
  },
  {
    path: '/Tools/:plantId',
    element: <InventoryCategoryLogs />,
    // authz-v2 TODO: StoreManagement_Manage_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Tools'),
  },
  {
    path: '/ToolForCleaning/:plantId',
    element: <InventoryCategoryLogs />,
    // authz-v2 TODO: StoreManagement_Manage_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Cleaning Tools'),
  },
  // {
  //   path: '/StoreManagement/:storeId',
  //   element: <StoreManagement />,
  //   loader: validatePermission('StoreManagement_Manage_WE'),
  //   handle: createCrumbHandle('Store Management'),
  // },
  // {
  //   path: '/StoreConfiguration',
  //   element: <StoreConfiguration />,
  //   loader: validatePermission('StoreConfiguration_Configuration_WE'),
  //   handle: createCrumbHandle('Stores'),
  // },
  {
    path: '/StoreConfiguration',
    handle: createCrumbHandle('Stores'),
    children: [
      {
        index: true,
        element: <StoreConfiguration />,
        // authz-v2 TODO: StoreConfiguration_Configuration_WE — gate server-side / useCan at component level
      },
      {
        path: 'StoreManagement/:storeId',
        element: withPostHogTracker(<StoreManagement />),
        // authz-v2 TODO: ViewAsUser_View_R — gate server-side / useCan at component level
        handle: createCrumbHandle('Store Management'),
      },
    ]
  },
  {
    path: '/StoreDetails',
    handle: createCrumbHandle('Store Details'),
    children: [
      {
        index: true,
        element: withPostHogTracker(<StoreDetails />),
        // authz-v2 TODO: StoreManagement_Manage_WE — gate server-side / useCan at component level
      },
      {
        path: 'ChemicalLogs',
        handle: createCrumbHandle('Chemical Logs'),
        children: [
          {
            index: true,
            element: withPostHogTracker(<ChemicalLog />),
            // authz-v2 TODO: StoreManagement_Manage_WE — gate server-side / useCan at component level
          },
          {
            path: 'SolutionDetailsForChemical',
            element: <SolutionDetailsForChemical />,
            // authz-v2 TODO: StoreManagement_Manage_WE — gate server-side / useCan at component level
            handle: createCrumbHandle('Solution Details For Chemical'),
          },
        ]
      },
    ]
  },
];

export default inventoryRoutes;